import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getBanners} from 'api/requests';
import {IBannersRequest, IBannersResponse} from 'types';

export interface UseBannersOptions extends UseQueryOptions<IBannersResponse[]> {
  locale?: string;
}

export const useBanners = (queryKey: QueryKey, params: IBannersRequest, options?: UseBannersOptions) => {
  const {locale, ...queryOptions} = options || {};

  return useQuery<IBannersResponse[]>({
    queryKey,
    queryFn: () => getBanners(params, locale),
    ...queryOptions,
  });
};
